module.exports = __webpack_public_path__ + "static/media/imgop_Systems.480608ce.jp2";